<template>
  <div>
    <Dialog
      :visible.sync="activityTypeForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Type Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="activityTypeCode">Type Code*</label>
          <InputText
            id="activityTypeCode"
            v-model.trim="activityType.activityTypeCode"
            required="true"
            autofocus
            :class="{
              'p-invalid': submitted && !activityType.activityTypeCode
            }"
            :disabled="disabledArr.includes('activityTypeCode')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !activityType.activityTypeCode"
            >ActivityType Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Color Code:</label>
          <Dropdown
            :showClear="true"
            v-model="activityType.colourCode"
            :options="colourCodes"
            optionLabel="label"
            dataKey="id"
            placeholder="Select Color Code"
            :disabled="disabledArr.includes('colourCode')"
          />
          <small class="p-invalid" v-if="submitted && !activityType.colourCode"
            >Status Colour Code is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="activityTypeName">Type Name*</label>
          <InputText
            id="activityTypeName"
            v-model.trim="activityType.activityTypeName"
            required="true"
            autofocus
            :class="{
              'p-invalid': submitted && !activityType.activityTypeName
            }"
            :disabled="disabledArr.includes('activityTypeName')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !activityType.activityTypeName"
            >ActivityType Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Mark Active</label>
          <SelectButton
            v-model="activityType.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="kind">Shows on</label>
          <Dropdown
            id="kind"
            v-model="activityType.kind"
            :options="kindOptions"
            optionLabel="label"
            optionValue="value"
            :disabled="disabledArr.includes('kind')"
          />
          <small>Changing this moves existing records of this type to the other list.</small>
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { KIND_OPTIONS } from "@/mbp/activityKind.js";

export default {
  props: [
    "activityTypeToEdit",
    "activityTypeForm",
    "disabledArr",
    "colourCodes"
  ],
  data: () => ({
    activityType: { kind: "TASK" },
    submitted: false,
    kindOptions: KIND_OPTIONS,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.activityTypeToEdit && this.activityTypeToEdit.id) {
      this.activityType = { ...this.activityTypeToEdit };
      this.activityTypeToEdit.active
        ? (this.activityType.active = { name: "Active", value: true })
        : (this.activityType.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    activityTypeForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.activityTypeForm ? true : false;
      }
    }
  },
  methods: {
    reset() {
      this.activityType = { kind: "TASK" };
    },
    save() {
      this.submitted = true;

      if (
        this.activityType.activityTypeCode &&
        this.activityType.activityTypeName &&
        this.activityType.colourCode
      ) {
        if (this.activityType.active instanceof Object) {
          this.activityType.active = this.activityType.active.value;
        }
        if (this.activityType.colourCode instanceof Object)
          this.activityType.colourCode = this.activityType.colourCode.value;

        this.$emit("save", this.activityType);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
